import { drag, event as d3Event, select } from 'd3';

//Co ordinates for draggable stick
const getStickCoordinate = ({ current, next, leftTopCoordinate, graphWidth, svgWidth }) => {
  let x = current;
  if (next <= leftTopCoordinate.x) {
    x = leftTopCoordinate.x;
  } else if (next >= graphWidth) {
    x = svgWidth;
  } else {
    x = next;
  }
  return x;
};

const timeInZero = (time) => {
  const timeInZero = time.split(':')[0] === '0';
  return timeInZero ? time.replace('0:', '12:') : time;
};

const getTimeFromXValue = ({ x, gridCellWidth, leftTopCoordinate }) => {
  //Find the time corresponding to stick position
  const oneHr = gridCellWidth;
  const oneMinute = gridCellWidth / 60;
  const hrs = Math.floor((x - leftTopCoordinate.x) / oneHr);

  const minutes = Math.floor((x - leftTopCoordinate.x) / oneMinute - hrs * 60);
  let currentTime = `${hrs < 12 ? hrs : Math.abs(12 - hrs)}:${minutes < 10 ? 0 : ''}${minutes}${hrs < 12 ? 'am' : 'pm'}`;
  if (currentTime === '0:00am' || currentTime === '12:00pm') {
    currentTime = '12:00am';
  }
  currentTime = timeInZero(currentTime);
  return currentTime;
};

export const changeStatusLine = ({
  event,
  editingArea,
  isDragged,
  setEditingArea,
  theme,
  origin,
  graphHeight,
  canEditRowByGraph,
  graphWidth,
  svgWidth,
  gridCellWidth,
  setIsDragged,
}) => {
  let currentDraggedData = {};

  const dragged = ({ draggedData, className, polyClassName }) => {
    //Find the position after moving left or right stick
    console.log(currentDraggedData)
    const x = getStickCoordinate({ current: draggedData[0].x, next: d3Event.x, leftTopCoordinate, graphWidth, svgWidth });
    const width = className === '.leftStick' ? editingArea.rx - x : editingArea.lx - x;

    //Disable if the sticks cross each other
    if ((width > 0 && className === '.leftStick') || (width < 0 && className === '.rightStick')) {
      const currentTime = getTimeFromXValue({ x, gridCellWidth, leftTopCoordinate });

      //Redraw the overlay based on the selection
      select(className)
        .attr('x1', () => x)
        .attr('x2', () => x);
      select(polyClassName).attr('points', () =>
        [
          [x, draggedData[0].y],
          [x - 5, draggedData[1].y],
          [x + 5, draggedData[2].y],
        ].join(' ')
      );

      if (className === '.leftStick') {
        select('.selectedArea')
          .attr('x', () => x)
          .attr('width', () => currentDraggedData.rx - x);
        select('.statusBar').attr('x1', () => x);
        select('.leftChip').attr('x', () => x - 10);
        select('.leftTime')
          .attr('x', () => x - 8)
          .text(() => currentTime);
        currentDraggedData = {
          ...currentDraggedData,
          lx: x,
          ltime: currentTime,
        };
      } else {
        select('.selectedArea').attr('width', () => x - currentDraggedData.lx);
        select('.statusBar').attr('x2', () => x);
        select('.rightChip').attr('x', () => x - 10);
        select('.rightTime')
          .attr('x', () => x - 8)
          .text(() => currentTime);
        currentDraggedData = {
          ...currentDraggedData,
          rx: x,
          rtime: currentTime,
        };
      }
    }
  };

  const dragStarted = (d) => {
    if (canEditRowByGraph) {
      //Get current editing area points
      currentDraggedData = { ...editingArea };
      setIsDragged(true);
      select(this).raise().classed('active', true);
    }
  };

  const dragEnded = (d) => {
    if (canEditRowByGraph) {
      setEditingArea({ ...currentDraggedData });
      currentDraggedData = {};
      select(this).classed('active', false);
    }
  };

  const rightDragged = (d) => {
    canEditRowByGraph &&
      dragged({
        draggedData: d,
        className: '.rightStick',
        polyClassName: '.rightPoly',
      });
  };

  const leftDragged = (d) => {
    canEditRowByGraph &&
      dragged({
        draggedData: d,
        className: '.leftStick',
        polyClassName: '.leftPoly',
      });
  };

  const leftTopCoordinate = origin || { x: 10, y: 10 };

  const leftPoly = [
    { x: leftTopCoordinate.x, y: graphHeight + 15 },
    { x: leftTopCoordinate.x - 5, y: graphHeight + 23 },
    { x: leftTopCoordinate.x + 5, y: graphHeight + 23 },
  ];

  // Right bottom triangle to drag
  const rightPoly = [
    { x: svgWidth, y: graphHeight + 15 },
    { x: svgWidth - 5, y: graphHeight + 23 },
    { x: svgWidth + 5, y: graphHeight + 23 },
  ];

  //Clear previous overlay
  select('svg > .overlay').remove();

  let statusLine;

  if (event && event.currentTarget) {
    // Individual status button click for add a row
    statusLine = event.currentTarget.dataset.value - 3;
  } else {
    //from useEffect when edit icon clicks
    statusLine = editingArea.ly;
  }

  //If status button clicks
  if (event) {
    setEditingArea({
      ...editingArea,
      ly: statusLine,
      ry: statusLine,
    });
  }

  //from useEffect when edit icon clicks or change status after drag the area
  if (isDragged || event === null) {
    const overlay = select('.svg-content').append('g').attr('class', 'overlay');

    const { lx, rx, ltime, rtime } = editingArea;
    const { y } = leftTopCoordinate;
    const secondaryColor = theme.palette.secondary.main;
    const strokeWidth = '0.5';
    const chipWidth = 19;
    const chipHeight = 9;
    const chipOffsetY = 10;

    // Draw status bar
    overlay
      .append('line')
      .attr('class', 'statusBar')
      .attr('x1', lx)
      .attr('y1', statusLine)
      .attr('x2', rx)
      .attr('y2', statusLine)
      .attr('stroke', secondaryColor)
      .style('stroke-width', '1.5');

    // Selected area rectangle
    overlay
      .append('rect')
      .attr('class', 'selectedArea')
      .attr('x', lx)
      .attr('y', y)
      .attr('width', rx - lx)
      .attr('height', graphHeight)
      .attr('stroke', 'none')
      .style('fill', 'rgba(245,130,32, 0.5)');

    // Helper: draw stick line
    const drawStick = (x, className) => {
      overlay
        .append('line')
        .attr('class', className)
        .attr('x1', x)
        .attr('y1', y)
        .attr('x2', x)
        .attr('y2', graphHeight + 21)
        .attr('stroke', secondaryColor)
        .style('stroke-width', strokeWidth);
    };

    // Helper: draw chip with time text
    const drawChip = (x, time, classPrefix) => {
      const group = overlay.append('g');

      group
        .append('rect')
        .attr('class', `${classPrefix}Chip`)
        .attr('x', x - 9)
        .attr('y', y + chipOffsetY)
        .attr('width', chipWidth)
        .attr('height', chipHeight)
        .attr('stroke', secondaryColor)
        .style('stroke-width', '0.7')
        .style('rx', '2')
        .style('fill', 'colors.WHITE');

      group
        .append('text')
        .attr('class', `${classPrefix}Time`)
        .attr('x', x - (classPrefix === 'left' ? 6.5 : 9))
        .attr('y', y + 16)
        .text(time.replace('edited', ''))
        .attr('font-size', '0.3rem')
        .attr('fill', 'colors.PRIMARY_CONTRAST');
    };

    // Helper: draw polygon and attach drag
    const drawPolygon = (points, className, dragHandler) => {
      overlay
        .data([points])
        .append('polygon')
        .attr('class', className)
        .attr('points', (d) => d.map((p) => `${p.x},${p.y}`).join(' '))
        .attr('transform', 'translate(0, 0)')
        .attr('fill', secondaryColor)
        .call(drag().on('start', dragStarted).on('drag', dragHandler).on('end', dragEnded));
    };

    // Left side
    drawStick(lx, 'leftStick');
    drawChip(lx, ltime, 'left');
    leftPoly[0].x = lx;
    leftPoly[1].x = lx - 5;
    leftPoly[2].x = lx + 5;
    drawPolygon(leftPoly, 'leftPoly', leftDragged);

    // Right side
    drawStick(rx, 'rightStick');
    drawChip(rx, rtime, 'right');
    rightPoly[0].x = rx;
    rightPoly[1].x = rx - 5;
    rightPoly[2].x = rx + 5;
    drawPolygon(rightPoly, 'rightPoly', rightDragged);
  }
};
